import PropTypes from "prop-types";

export default function SizeProps() {
  return PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.func
  ]);
}
